import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class RoutingOptionsForm extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var routingOptions = this;
		setTimeout(function(){
			routingOptions.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var routingOptions = this;
		
		//get Available options
		var primaryContainer = ElementUtil.create({
			tag: 'div',
			style: 'max-width: 100%; min-width: 0; box-sizing: border-box;'			
		});
		
		var loadMask = primaryContainer.showLoading();		
		RoutingService.getGeospatialOptionsService().getEnignes().then(function(engines){
			Service.getLookupService().getLookupValues('RoutingPreferenceType').then(function(preferenceTypes){
				loadMask.remove();

				//render
				routingOptions.engineContainer = ElementUtil.create({
					tag: 'fieldset',
					style: 'margin-bottom: 20px',
					children: [
						{
							tag: 'legend',
							innerHTML: 'Engine'
						},
						{
							tag: 'dl-form-panel',
							itemId: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',
									style: 'width: 100%; max-width: 100%; box-sizing: border-box;',									
									children: [
										{
											tag: 'vaadin-combo-box',
											itemId: 'engine',
											label: 'Engines', 
											name: 'engine',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											postinit: function(combo) {
												var lookups = [];
												engines.forEach(function(engine) {
													lookups.push({
														code: engine.engineKey,
														description: engine.engineDescription,
														engine: engine
													});
												});
												combo.items = lookups;
												combo.value = engines[0].engineKey;																							
											},
											listeners: {
												change: function(e) {											
													var engineCB = ElementUtil.query(routingOptions.engineContainer, 'engine');
													actionUpdateOptions(engineCB.selectedItem.engine);
												}
											}
										},
										{
											tag: 'vaadin-combo-box',
											itemId: 'engineVersions',
											label: 'Engine Versions', 
											name: 'version',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											postinit: function(combo) {																							
											}											
										}
									]
								}
							]
						}
					]
				});
				
				routingOptions.optionContainer = ElementUtil.create({
					tag: 'fieldset',
					children: [
						{
							tag: 'legend',
							innerHTML: 'Options'
						}, 
						{
							tag: 'dl-tabpanel',
							itemId: 'tabPanel',
							listeners: {
								ready: function() {
									var engineCB = ElementUtil.query(routingOptions.engineContainer, 'engine');
									actionUpdateOptions(engineCB.selectedItem.engine);
								}
							}
						}
					]
				});

				primaryContainer.append(routingOptions.engineContainer);
				primaryContainer.append(routingOptions.optionContainer);

				//fire event on ready
				var readyEvent = new CustomEvent('ready', { detail: '' });
				routingOptions.dispatchEvent(readyEvent);				
				
				
				var actionUpdateOptions = function(engine) {

					var versionCB = ElementUtil.query(routingOptions.engineContainer, 'engineVersions');
					var versions = [];
					engine.availableVersions.forEach(function(version) {
						versions.push({
							code: version,
							description: version
						});
					});
					versionCB.items = versions;	
					versionCB.value = versions[0].code;
					
					renderOptions(engine);
				};

				var renderOptions = function(engine) {
					
					var tabPanel  = ElementUtil.query(routingOptions.optionContainer, 'tabPanel');
				
					
					var availableOptions = engine.options;
					var defaultOptions = engine.defaultOptions;
					
					var fields = [];
					var afterField = [];
					availableOptions.forEach(function(optionDefinition) {
						
						if (optionDefinition.dataType === 'Boolean') {
							var chkDef = {
								tag: 'vaadin-checkbox',
								name: optionDefinition.optionName,
								label: optionDefinition.description,
								required: optionDefinition.required
							};
							if (optionDefinition.defaultValueBoolean) {
								chkDef.checked = true;
							}
							fields.push(chkDef);
						} else if (optionDefinition.dataType === 'List') {
							fields.push({
								tag: 'vaadin-combo-box',
								name: optionDefinition.optionName,
								label: optionDefinition.description,
								required: optionDefinition.required,
								'item-value-path': 'code',
								'item-label-path': 'description',
								postinit: function (combo) {
									optionDefinition.lookups.sort(function (a, b) {
										return a.description.localeCompare(b.description);
									});
									combo.items = optionDefinition.lookups;
									combo.value = optionDefinition.defaultValueString;								
								}
							});
						} else if (optionDefinition.dataType === 'String') {
							fields.push({
								tag: 'vaadin-text-field',
								name: optionDefinition.optionName,
								label: optionDefinition.description,
								required: optionDefinition.required
							});
						} else if (optionDefinition.dataType === 'TollDiscount') {
							//there will be only only of these							
							fields.push({
								tag: 'dl-toll-discount',
								itemId: 'toll-discount',
								name: optionDefinition.optionName,
								label: optionDefinition.description,
								required: optionDefinition.required,								
								colspan: 2,
								style: 'border: 1px gray solid; height: 200px; width: 100%; max-width: 100%; min-width: 0; box-sizing: border-box;',
								listeners: {
									ready: function(e) {										
										e.detail.options = optionDefinition.lookups;										
									}
								}
							});
						}
						
					});					
					
					//add elements		
					var tabs = [];
					routingOptions.preferenceTypes = preferenceTypes;
					
					var allFields = [
						{
							tag: 'vaadin-form-layout',
							style: 'padding: 10px; width: 100%; max-width: 100%; box-sizing: border-box;',
							children: fields
						}								
					];
					//allFields = allFields.concat(afterField);
					
					preferenceTypes.forEach(function(type){
						tabs.push({
							'tab-title': type.description,
							'tab-title-trusted': false,
							tag: 'dl-form-panel',
							itemId: 'option-form-' + type.code,
							children: allFields		
						});						
					});
					tabPanel.addTabs(tabs);
					
				};
				
			});			
		});				
		routingOptions.append(primaryContainer);
		
	}
	
	/**
	 * Call this after the 'ready' event
	 * @param {type} options
	 * @returns {RoutingOptionsForm.loadOptions.geoOptions}
	 */
	loadOptions(options) {
		var routingOptions = this;
		
		routingOptions.loadedOptions = options;
		
		var engineForm = ElementUtil.query(routingOptions.engineContainer, 'form');
		engineForm.load(options);
		
		routingOptions.preferenceTypes.forEach(function(type){
			var engineOptionForm = ElementUtil.query(routingOptions.optionContainer, 'option-form-' + type.code);
			engineOptionForm.load(options.routeOptions[type.code].options);			
			
			//toll discounts
			var tollDiscounts = options.routeOptions[type.code].options['TOLL_DISCOUNT'];
			if (tollDiscounts) {			
				var tollDiscountsField = ElementUtil.query(engineOptionForm, 'toll-discount');
				if (tollDiscounts.split) {
					tollDiscountsField.setValues(tollDiscounts.split(','));
				} else {
					tollDiscountsField.setValues([tollDiscounts]);
				}
			}
			
		});
		
		
		
	}
	
	getOptions() {		
		var routingOptions = this;
		
		var engineForm = ElementUtil.query(routingOptions.engineContainer, 'form');
		var engineData = engineForm.getData();		
		
		var geoOptions = {
			engine: engineData.engine,
			version: engineData.version,
			routeOptions: {				
			}
		};
		
		if (routingOptions.loadedOptions && routingOptions.loadedOptions.engineOptionsId) {
			geoOptions.engineOptionsId = routingOptions.loadedOptions.engineOptionsId;
		}
		
		routingOptions.preferenceTypes.forEach(function(type){
			var engineOptionForm = ElementUtil.query(routingOptions.optionContainer, 'option-form-' + type.code);
			var optionData = engineOptionForm.getData();
			
			geoOptions.routeOptions[type.code] = {
				options: {					
				}
			};
			
			for(var key in optionData) {
				geoOptions.routeOptions[type.code].options[key] = optionData[key];
			}
			
			var tollDiscountField = ElementUtil.query(engineOptionForm, 'toll-discount');
			var tollDiscountValue = tollDiscountField.getValues();
			if (tollDiscountValue && tollDiscountValue.length > 0) {
								
				geoOptions.routeOptions[type.code].options['TOLL_DISCOUNT'] = tollDiscountValue.join(',');
			}
			
		});
		
		return geoOptions;
	}
	
}
customElements.define('dl-routing-options-form', RoutingOptionsForm);